<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt u-no-pb">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div style="text-align: center">
					<img alt="Insurance contract picture" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/insurance-icon-1.svg" class="c-image c-image--lg" />
				</div>
				<p class="c-text c-text--lg c-text--center u-ost-xl">
					{{'Insurance_Attention.Insurance_Activation' | translate}}
				</p>
				<p class="c-text u-ost-xl">
					{{('Insurance_Attention.Add_Details' | translate).replace('%s', vm.incompletePolicy.policy.policyNumber)}}
				</p>
				<div class="c-panel u-no-p u-ost-sm u-osb-sm">
					<div class="o-grid o-grid--bottom o-grid--wrap u-osb-lg">
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-md">
							<button id="postponeButton" (click)="vm.close()" class="c-button c-button--s1 u-no-wrap" type="button">
								{{'Insurance_Attention.Later' | translate}}
							</button>
						</div>
						<div class="o-grid__cell u-no-p"></div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p u-ost-md">
							<button id="continueCompletingInsuranceButton" (click)="vm.submit()" class="c-button c-button--s1 u-no-wrap" type="button">
								{{'Insurance_Attention.Continue' | translate}}
							</button>
						</div>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing || !vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
